import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import ScrollToTop from "./components/ScrollToTop";
import Landing from "./pages/Landing";
import Legal from "./pages/Legal";

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <ScrollToTop />
        <Routes>
          <Route path="/legal" element={<Legal />} />
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
        <Toaster theme="dark" position="bottom-center" />
      </SmoothScroll>
    </BrowserRouter>
  );
}